import { render, staticRenderFns } from "./BtArticolo.vue?vue&type=template&id=1ea4956a"
import script from "./BtArticolo.vue?vue&type=script&lang=js"
export * from "./BtArticolo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports